import React, { useEffect, useRef } from 'react'
import './Delivery.css'
import Aos from 'aos';
import 'aos/dist/aos.css';


function Delivery() {
  const ref = useRef(null);
  const appDevRef = useRef(null);

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div ref={ref}>
    <div className="serviceaboutsection">
      <div className="aboutcontent" id="appdevelopment" ref={appDevRef}>
        <div  className="delivery-text-center">
          <h1>Delivery App Development</h1>
          <div className="delivery-underline"></div>
          <p>
            Turn your business ideas into powerful mobile apps with Phoenix
            Marketing. Our app development team builds user-friendly, scalable
            mobile apps tailored to your business goals. Whether its Android,
            iOS, or cross-platform, we deliver performance-driven solutions that
            help your brand stay connected with customers anytime, anywhere.
          </p>
        </div>

        <div className="aboutsection-image-all-service-delivery">
          <img src="/Imagefile/Delivery App Development.png" className="aboutsection-image" />
        </div>
      </div>
    </div>
  </div>
  );
};


export default Delivery

